import { createRouter, createWebHistory } from 'vue-router'
import ImageGrid from './components/ImageGrid.vue';
import PageOne from './components/LayerPage1.vue'
import PageTwo from './components/LayerPage2.vue'
import PageThree from './components/LayerPage3.vue'
import PageFour from './components/LayerPage4.vue'
import PageFive from './components/LayerPage5.vue'
import PageSix from './components/LayerPage6.vue'
import PageSeven from './components/LayerPage7.vue'
import PageEight from './components/LayerPage8.vue'
import TestHelper from './components/TestHelper.vue'

const routes = [
  { path: '/', component: ImageGrid},
  { path: '/page1', component: PageOne },
  { path: '/page2', component: PageTwo },
  { path: '/page3', component: PageThree },
  { path: '/page4', component: PageFour },
  { path: '/page5', component: PageFive },
  { path: '/page6', component: PageSix },
  { path: '/page7', component: PageSeven },
  { path: '/page8', component: PageEight },
  { path: '/test', component: TestHelper }
]
// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: HomeView
//   },
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   }
// ]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router


// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import PageOne from '@/components/LayerPage1.vue'
// import PageTwo from '@/components/LayerPage2.vue'
// import PageThree from '@/components/LayerPage3.vue'
// import PageFour from '@/components/LayerPage4.vue'

// Vue.use(VueRouter)



// const router = new VueRouter({
//   routes
// })

// export default router